(function () {
    'ngInject';

    angular.module('app.shared.services').factory('OpenAIAPIService', openAIAPIService);

    function openAIAPIService(HttpService) {
        const baseURL = 'https://api.openai.com';
        const textToImageURL = `${baseURL}/v1/images/generations`;
        const imageToImageURL = `${baseURL}/v1/images/edits`;

        const imageToImageBackendUrl = '/api/OpenAi/ImageToImage';

        function isValidAPIKey(key) {
            //TODO: Validate key when user enters it.
        }

        async function textToImage(key, typedText) {
            var myHeaders = new Headers();
            myHeaders.append('Content-Type', 'application/json');
            myHeaders.append('Authorization', 'Bearer ' + key);

            var raw = JSON.stringify({
                model: 'dall-e-3',
                prompt: typedText,
                n: 1,
                size: '1024x1024',
                response_format: 'b64_json'
            });

            var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: raw,
                redirect: 'follow'
            };

            try {
                const response = await fetch(textToImageURL, requestOptions);
                const result = await response.text();
                return result;
            } catch (error) {
                console.log('error', error);
                throw error;
            }
        }

        async function imageToImageOnBackendServer(username, imageFile, config) {
            const { prompt, quality, size, background } = config;

            const formData = new FormData();
            formData.append('username', username);
            formData.append('prompt', prompt);
            if (quality) formData.append('quality', quality);
            if (size) formData.append('size', size);
            if (background) formData.append('background', background);
            formData.append('image', imageFile);

            try {
                const response = await fetch(imageToImageBackendUrl, {
                    method: 'POST',
                    body: formData
                });
                return await response.json();
            } catch (error) {
                console.log('error', error);
                throw error;
            }
        }

        async function imageToImage(key, image, prompt) {
            var myHeaders = new Headers();
            myHeaders.append('Authorization', 'Bearer ' + key);

            const form = new FormData();
            form.append('model', 'gpt-image-1');
            form.append('prompt', prompt);
            form.append('n', 1);
            form.append('size', 'auto');
            form.append('quality', 'low');
            form.append('image', image);

            var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: form,
                redirect: 'follow'
            };

            try {
                const response = await fetch(imageToImageURL, requestOptions);
                const result = await response.text();
                return result;
            } catch (error) {
                console.log('error', error);
                throw error;
            }
        }

        return {
            textToImage,
            imageToImage,
            imageToImageOnBackendServer
        };
    }
})();
